/**
 * Shared date formatter utility
 * Formats dates in human-readable format: "12 Sep 2025, 3:45 PM"
 * @param {string|Date} dateString - ISO date string or Date object
 * @returns {string|null} Formatted date string or null if invalid
 */
export function formatDate(dateString) {
  if (!dateString) return null;
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return null;
    
    // Format: "12 Sep 2025, 3:45 PM"
    return new Intl.DateTimeFormat('en-US', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    }).format(date);
  } catch {
    return null;
  }
}

export default formatDate;

